import React, { ReactElement } from "react";
import ReactDOM from "react-dom";
import { DialogPortalOverlay } from "./style";

const DialogPortal = ({
  children,
  zIndex,
}: {
  children: ReactElement;
  zIndex?: string;
}) => {
  const el = document.getElementById("dialog-root");
  if (el) {
    return ReactDOM.createPortal(
      <DialogPortalOverlay
        $zIndex={zIndex}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        {children}
      </DialogPortalOverlay>,
      el
    );
  } else return children;
};

export default DialogPortal;
